import { render, staticRenderFns } from "./header.vue?vue&type=template&id=75b45a93&scoped=true&v-if=lang&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=75b45a93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b45a93",
  null
  
)

export default component.exports